
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOnboardingContext } from '@/context/OnboardingContext';

const RootRedirect: React.FC = () => {
  const { isLoading, onboardingComplete } = useOnboardingContext();

  console.log('RootRedirect - isLoading:', isLoading, 'onboardingComplete:', onboardingComplete);

  // Show loading while checking onboarding status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // Redirect based on onboarding status
  if (onboardingComplete) {
    console.log('RootRedirect - Redirecting to /home');
    return <Navigate to="/home" replace />;
  } else {
    console.log('RootRedirect - Redirecting to /onboarding');
    return <Navigate to="/onboarding" replace />;
  }
};

export default RootRedirect;
